// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as enums from '@trialcard/enums';
export const PharmacySpecialization = enums.PharmacySpecialization;
//# sourceMappingURL=pharmacySpecialization.js.map